import { getLocalStore, setLocalStore, removeLocalStore } from './util'

const AccessId = 'Access-Id'
const UserName = 'User-Name'
const UserPhone = 'User-Phone'
const DeliveryAddress = 'Delivery-Address'
const ImageUrl = 'Image-Url'

export function getAccessId () {
  return getLocalStore(AccessId)
}

export function setAccessId (id) {
  return setLocalStore(AccessId, id)
}

export function removeAccessId () {
  return removeLocalStore(AccessId)
}

export function getImageUrl () {
  return getLocalStore(ImageUrl)
}

export function setImageUrl (imageUrl) {
  return setLocalStore(ImageUrl, imageUrl)
}

export function removeImageUrl () {
  return removeLocalStore(imageUrl)
}
export function getUserName () {
  return getLocalStore(UserName)
}

export function setUserName (name) {
  return setLocalStore(UserName, name)
}

export function removeUserName () {
  return removeLocalStore(UserName)
}

export function getUserPhone () {
  return getLocalStore(UserPhone)
}

export function setUserPhone (phone) {
  return setLocalStore(UserPhone, phone)
}

export function removeUserPhone () {
  return removeLocalStore(UserPhone)
}

export function getDeliveryAddress () {
  return getLocalStore(DeliveryAddress)
}

export function setDeliveryAddress (address) {
  return setLocalStore(DeliveryAddress, address)
}

export function removeDeliveryAddress () {
  return removeLocalStore(DeliveryAddress)
}